(() => {
  'use strict';

  /**
   * ROOKIE STYLE コーデ詳細
   */
  const initializeRookieStyleCoordinate = (root) => {
    if (!root || root.dataset.rsInitialized === 'true') {
      return;
    }

    root.dataset.rsInitialized = 'true';

    /**
     * Shopifyの言語・マーケット付きルートに対応
     */
    const getRoute = (path) => {
      const shopRoot = window.Shopify?.routes?.root || '/';

      return `${shopRoot}${path.replace(/^\/+/, '')}`;
    };

    /**
     * カート件数を取得し、ヘッダーへ反映
     */
    const updateCartCount = async () => {
      try {
        const response = await fetch(getRoute('cart.js'), {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('カート情報を取得できませんでした。');
        }

        const cart = await response.json();

        /*
         * Dawn系・header-typeE用
         */
        const cartBubble = document.getElementById('cart-icon-bubble');

        if (cartBubble) {
          let countBubble = cartBubble.querySelector('.cart-count-bubble');

          if (cart.item_count > 0) {
            if (!countBubble) {
              countBubble = document.createElement('div');
              countBubble.className = 'cart-count-bubble';

              countBubble.innerHTML = `
                <span aria-hidden="true"></span>
                <span class="visually-hidden"></span>
              `;

              cartBubble.appendChild(countBubble);
            }

            const visibleCount = countBubble.querySelector(
              'span[aria-hidden="true"]'
            );

            const accessibleCount = countBubble.querySelector(
              '.visually-hidden'
            );

            if (visibleCount) {
              visibleCount.textContent = cart.item_count;
            }

            if (accessibleCount) {
              accessibleCount.textContent =
                `カート内の商品数：${cart.item_count}`;
            }

            countBubble.classList.remove('hidden');
          } else if (countBubble) {
            countBubble.classList.add('hidden');
          }
        }

        /*
         * 同一ページ内に別のカート件数表示がある場合
         */
        document
          .querySelectorAll('[data-cart-count]')
          .forEach((element) => {
            element.textContent = cart.item_count;
          });

        /**
         * 他のテーマJSからも利用できるようイベント通知
         */
        document.dispatchEvent(
          new CustomEvent('rookie-style:cart-updated', {
            detail: {
              cart
            }
          })
        );

        return cart;
      } catch (error) {
        console.error('ROOKIE STYLE: カート件数更新エラー', error);

        return null;
      }
    };

    /**
     * Ajax Cart APIへ商品を追加
     */
    const addItemsToCart = async (items) => {
      const response = await fetch(getRoute('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items
        })
      });

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData.description ||
          responseData.message ||
          'カートへの追加に失敗しました。';

        throw new Error(errorMessage);
      }

      await updateCartCount();

      return responseData;
    };

    /**
     * コーデ画像切り替え
     */
    /**
 * コーデ画像Swiper
 */
const initializeCoordinateSwiper = () => {
  const mainSwiperElement = root.querySelector(
    '[data-rs-main-swiper]'
  );

  const thumbSwiperElement = root.querySelector(
    '[data-rs-thumb-swiper]'
  );

  if (
    !mainSwiperElement ||
    !thumbSwiperElement ||
    typeof window.Swiper !== 'function'
  ) {
    return;
  }

  /*
   * テーマエディタでの再読み込み時に
   * 二重初期化しない
   */
  if (
    mainSwiperElement.swiper ||
    thumbSwiperElement.swiper
  ) {
    return;
  }

  const thumbnailSwiper = new window.Swiper(
    thumbSwiperElement,
    {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true
    }
  );

  const previousButton = root.querySelector(
    '[data-rs-swiper-prev]'
  );

  const nextButton = root.querySelector(
    '[data-rs-swiper-next]'
  );

  const mainSwiper = new window.Swiper(mainSwiperElement, {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 400,
  loop: false,
  grabCursor: true,
  watchOverflow: true,

  navigation: {
    prevEl: previousButton,
    nextEl: nextButton
  },

  thumbs: {
    swiper: thumbnailSwiper
  },

  keyboard: {
    enabled: true,
    onlyInViewport: true
  },

  a11y: {
    enabled: true,
    prevSlideMessage: '前の画像',
    nextSlideMessage: '次の画像',
    firstSlideMessage: '最初の画像です',
    lastSlideMessage: '最後の画像です',
    slideLabelMessage: '{{index}} / {{slidesLength}}'
  }
});

/*
 * サムネイルボタンからメインSwiperを明示的に切り替える
 */
const thumbnailSlides = Array.from(
  thumbSwiperElement.querySelectorAll('.swiper-slide')
);

thumbnailSlides.forEach((slide, index) => {
  const button = slide.querySelector('.rs-thumb');

  if (!button) {
    return;
  }

  button.addEventListener('click', (event) => {
    event.preventDefault();

    mainSwiper.slideTo(index);
  });
});

};

    /**
     * 商品カード
     */
    class RookieStyleProduct {
      constructor(element) {
        this.element = element;
        this.isReady = false;

        const jsonElement = element.querySelector(
          '[data-rs-product-json]'
        );

        if (!jsonElement) {
          console.warn(
            'ROOKIE STYLE: 商品JSONが見つかりません。',
            element
          );

          return;
        }

        try {
          this.data = JSON.parse(jsonElement.textContent);
        } catch (error) {
          console.error(
            'ROOKIE STYLE: 商品JSONの解析に失敗しました。',
            error
          );

          return;
        }

        this.variants = Array.isArray(this.data.variants)
          ? this.data.variants
          : [];

        this.colorOptionIndex = Number(
          this.data.colorOptionIndex
        );

        this.sizeOptionIndex = Number(
          this.data.sizeOptionIndex
        );

        this.productImage = element.querySelector(
          '[data-rs-product-image]'
        );

        this.priceElement = element.querySelector(
          '[data-rs-price]'
        );

        this.comparePriceElement = element.querySelector(
          '[data-rs-compare-price]'
        );

        this.saleBadgeElement = element.querySelector(
          '[data-rs-sale-badge]'
        );

        this.selectedColorElement = element.querySelector(
          '[data-rs-selected-color]'
        );

        this.selectedSizeElement = element.querySelector(
          '[data-rs-selected-size]'
        );

        this.soldOutElement = element.querySelector(
          '[data-rs-soldout]'
        );

        this.addButton = element.querySelector(
          '[data-rs-add]'
        );

        this.messageElement = element.querySelector(
          '[data-rs-message]'
        );

        this.colorButtons = Array.from(
          element.querySelectorAll('[data-rs-color]')
        );

        this.sizeButtons = Array.from(
          element.querySelectorAll('[data-rs-size]')
        );

        this.currentVariant =
          this.variants.find(
            (variant) =>
              String(variant.id) ===
              String(this.data.initialVariantId)
          ) ||
          this.variants.find((variant) => variant.available) ||
          this.variants[0] ||
          null;

        this.selectedOptions = this.currentVariant
          ? [...this.currentVariant.options]
          : [];

        this.bindEvents();
        this.update();

        this.isReady = true;
      }

      /**
       * カラー・サイズ・カートボタンイベント
       */
      bindEvents() {
        this.colorButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) {
              return;
            }

            const optionValue = button.dataset.optionValue;

            if (
              this.colorOptionIndex < 0 ||
              !optionValue
            ) {
              return;
            }

            this.selectedOptions[this.colorOptionIndex] =
              optionValue;

            this.clearMessage();
            this.update();
          });
        });

        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) {
              return;
            }

            const optionValue = button.dataset.optionValue;

            if (
              this.sizeOptionIndex < 0 ||
              !optionValue
            ) {
              return;
            }

            this.selectedOptions[this.sizeOptionIndex] =
              optionValue;

            this.clearMessage();
            this.update();
          });
        });

        if (this.addButton) {
          this.addButton.addEventListener('click', async () => {
            await this.addCurrentVariant();
          });
        }
      }


      /**
       * 選択肢と完全一致するバリエーションを取得
       */
      getSelectedVariant() {
        return (
          this.variants.find((variant) => {
            return variant.options.every(
              (optionValue, optionIndex) =>
                optionValue ===
                this.selectedOptions[optionIndex]
            );
          }) || null
        );
      }

      /**
       * カラー在庫状態を更新
       */
  updateColorButtons() {
  if (this.colorOptionIndex < 0) {
    return;
  }

  this.colorButtons.forEach((button) => {
    const colorValue = button.dataset.optionValue;

    const colorAvailable = this.variants.some(
      (variant) =>
        variant.available &&
        variant.options[this.colorOptionIndex] ===
          colorValue
    );

    const isSelected =
      colorValue ===
      this.selectedOptions[this.colorOptionIndex];

    /*
     * 全サイズ在庫0でもカラーは選択可能。
     * 見た目だけSOLD OUT状態にする。
     */
    button.disabled = false;

    button.classList.toggle(
      'is-sold-out',
      !colorAvailable
    );

    button.classList.toggle(
      'is-active',
      isSelected
    );

    button.setAttribute(
      'aria-pressed',
      isSelected ? 'true' : 'false'
    );
  });
}

      /**
       * 選択カラーに応じたサイズ在庫状態を更新
       */
      updateSizeButtons() {
        if (this.sizeOptionIndex < 0) {
          return;
        }

        this.sizeButtons.forEach((button) => {
          const sizeValue = button.dataset.optionValue;

          const sizeAvailable = this.variants.some(
            (variant) => {
              if (!variant.available) {
                return false;
              }

              const sizeMatches =
                variant.options[this.sizeOptionIndex] ===
                sizeValue;

              if (this.colorOptionIndex < 0) {
                return sizeMatches;
              }

              const colorMatches =
                variant.options[this.colorOptionIndex] ===
                this.selectedOptions[this.colorOptionIndex];

              return sizeMatches && colorMatches;
            }
          );

          const isSelected =
            sizeValue ===
            this.selectedOptions[this.sizeOptionIndex];

          button.disabled = !sizeAvailable;
          button.classList.toggle('is-active', isSelected);

          button.setAttribute(
            'aria-pressed',
            isSelected ? 'true' : 'false'
          );
        });
      }

      /**
       * 選択表示、画像、価格、カートボタンを更新
       */
      update() {
        this.updateColorButtons();
        this.updateSizeButtons();

        this.currentVariant = this.getSelectedVariant();

        if (!this.currentVariant) {
          this.element.dataset.selectedVariantId = '';

          if (this.addButton) {
            this.addButton.disabled = true;
            this.addButton.textContent =
              '組み合わせを選択してください';
          }

          return;
        }

        this.element.dataset.selectedVariantId =
          this.currentVariant.id;

        if (
          this.selectedColorElement &&
          this.colorOptionIndex >= 0
        ) {
          this.selectedColorElement.textContent =
            this.currentVariant.options[
              this.colorOptionIndex
            ];
        }

        if (
          this.selectedSizeElement &&
          this.sizeOptionIndex >= 0
        ) {
          this.selectedSizeElement.textContent =
            this.currentVariant.options[
              this.sizeOptionIndex
            ];
        }

        if (
          this.productImage &&
          this.currentVariant.image &&
          this.productImage.src !== this.currentVariant.image
        ) {
          this.productImage.style.opacity = '.35';

          const preloadImage = new Image();

          preloadImage.onload = () => {
            this.productImage.src =
              this.currentVariant.image;

            this.productImage.removeAttribute('srcset');

            requestAnimationFrame(() => {
              this.productImage.style.opacity = '';
            });
          };

          preloadImage.onerror = () => {
            this.productImage.style.opacity = '';
          };

          preloadImage.src = this.currentVariant.image;
        }

        if (this.priceElement) {
          this.priceElement.textContent =
            this.currentVariant.priceFormatted;
        }

        const hasComparePrice =
          Number(this.currentVariant.compareAtPrice) >
          Number(this.currentVariant.price);

        if (this.comparePriceElement) {
          this.comparePriceElement.hidden =
            !hasComparePrice;

          this.comparePriceElement.textContent =
            hasComparePrice
              ? this.currentVariant
                  .compareAtPriceFormatted || ''
              : '';
        }

        const compareAtPrice = Number(
  this.currentVariant.compareAtPrice || 0
);

const currentPrice = Number(
  this.currentVariant.price || 0
);

const discountPercent =
  compareAtPrice > currentPrice && compareAtPrice > 0
    ? Math.round(
        ((compareAtPrice - currentPrice) * 100) /
        compareAtPrice
      )
    : 0;

if (this.saleBadgeElement) {
  this.saleBadgeElement.hidden = discountPercent <= 0;

  this.saleBadgeElement.textContent =
    discountPercent > 0
      ? `${discountPercent}%OFF`
      : '';
}

        const isAvailable =
          Boolean(this.currentVariant.available);

        if (this.addButton) {
          this.addButton.disabled = !isAvailable;

          this.addButton.textContent = isAvailable
            ? 'カートに追加する'
            : 'SOLD OUT';
        }

        if (this.soldOutElement) {
          this.soldOutElement.hidden = isAvailable;
        }

        root.dispatchEvent(
          new CustomEvent(
            'rookie-style:variant-changed',
            {
              bubbles: true,
              detail: {
                productId: this.data.productId,
                variant: this.currentVariant
              }
            }
          )
        );
      }

      /**
       * 単品カート追加
       */
      async addCurrentVariant() {
        if (
          !this.currentVariant ||
          !this.currentVariant.available ||
          !this.addButton
        ) {
          return;
        }

        this.setLoading(true);
        this.clearMessage();

        try {
          await addItemsToCart([
            {
              id: Number(this.currentVariant.id),
              quantity: 1
            }
          ]);

          this.setMessage(
            '商品をカートに追加しました。'
          );
        } catch (error) {
          this.setMessage(error.message, true);
        } finally {
          this.setLoading(false);
        }
      }

      /**
       * ローディング表示
       */
      setLoading(isLoading) {
        if (!this.addButton) {
          return;
        }

        this.addButton.disabled = isLoading;

        if (isLoading) {
          this.addButton.textContent = '追加中...';
        } else {
          const isAvailable =
            Boolean(this.currentVariant?.available);

          this.addButton.disabled = !isAvailable;

          this.addButton.textContent = isAvailable
            ? 'カートに追加する'
            : 'SOLD OUT';
        }
      }

      /**
       * メッセージ表示
       */
      setMessage(message, isError = false) {
        if (!this.messageElement) {
          return;
        }

        this.messageElement.textContent = message;

        this.messageElement.classList.toggle(
          'is-error',
          isError
        );
      }

      clearMessage() {
        this.setMessage('', false);
      }
    }

    /**
     * 商品カード初期化
     */
    const productInstances = Array.from(
      root.querySelectorAll('[data-rs-product]')
    )
      .map(
        (productElement) =>
          new RookieStyleProduct(productElement)
      )
      .filter((product) => product.isReady);

    /**
     * まとめてカート追加
     */
    const addAllButton = root.querySelector(
      '[data-rs-add-all]'
    );

    const allMessageElement = root.querySelector(
      '[data-rs-all-message]'
    );

    const setAllMessage = (
      message,
      isError = false
    ) => {
      if (!allMessageElement) {
        return;
      }

      allMessageElement.textContent = message;

      allMessageElement.classList.toggle(
        'is-error',
        isError
      );
    };

    if (addAllButton) {
      addAllButton.addEventListener(
        'click',
        async () => {
          setAllMessage('', false);

          const unavailableProducts =
            productInstances.filter(
              (product) =>
                !product.currentVariant ||
                !product.currentVariant.available
            );

          /*
           * 1商品でも選択中バリエーションが購入不可なら
           * 意図せず一部だけ追加されないよう処理を止める
           */
          if (unavailableProducts.length > 0) {
            setAllMessage(
              '在庫切れまたは選択できていない商品があります。',
              true
            );

            return;
          }

          const items = productInstances.map(
            (product) => ({
              id: Number(product.currentVariant.id),
              quantity: 1
            })
          );

          if (items.length === 0) {
            setAllMessage(
              '追加できる商品がありません。',
              true
            );

            return;
          }

          addAllButton.disabled = true;
          addAllButton.textContent = '追加中...';

          try {
            await addItemsToCart(items);

            setAllMessage(
              '商品をまとめてカートに追加しました。'
            );
          } catch (error) {
            setAllMessage(error.message, true);
          } finally {
            addAllButton.disabled = false;

            addAllButton.textContent =
              'まとめてカートに追加する';
          }
        }
      );
    }

    /**
     * お気に入りはVer.2で正式実装
     * Ver.1では押下状態の表示のみ
     */
    const favoriteButton = root.querySelector(
      '[data-rs-favorite]'
    );

    if (favoriteButton) {
      favoriteButton.addEventListener('click', () => {
        const isPressed =
          favoriteButton.getAttribute(
            'aria-pressed'
          ) === 'true';

        favoriteButton.setAttribute(
          'aria-pressed',
          isPressed ? 'false' : 'true'
        );

        favoriteButton.textContent =
          isPressed ? '♡' : '♥';
      });
    }

    initializeCoordinateSwiper();
  };

  /**
   * defer読み込みのため通常はDOMContentLoaded後ですが、
   * テーマエディタでの再描画にも対応
   */
  const initializeAll = () => {
    document
      .querySelectorAll('[data-rs-coordinate]')
      .forEach((root) => {
        initializeRookieStyleCoordinate(root);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll,
      {
        once: true
      }
    );
  } else {
    initializeAll();
  }

  /**
   * Shopifyテーマエディタでセクション再読み込み時
   */
  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );


document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-rs-product-link]');
  if (!link) return;

  const productCard = link.closest('[data-rs-product]');
  if (!productCard) return;

  if (
    !window.Shopify ||
    !Shopify.analytics ||
    typeof Shopify.analytics.publish !== 'function'
  ) {
    return;
  }

  Shopify.analytics.publish('rookie_style:product_click', {
    coordinate_id: productCard.dataset.coordinateId || '',
    coordinate_title: productCard.dataset.coordinateTitle || '',
    product_id: productCard.dataset.productId || '',
    product_title: productCard.dataset.productTitle || '',
    product_url: productCard.dataset.productUrl || ''
  });
});

})();